export enum DocumentSignStatusEnum {
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  SIGNED = 'SIGNED',
  SIGNED_FULL = 'SIGNED_FULL',
  PROCESSING = 'PROCESSING',
  CANCELLED = 'CANCELLED',
  ERROR = 'ERROR',
}

export enum DocumentSignStatusEditableEnum {
  CREATED = 'CREATED',
  PENDING = 'PENDING',
}
